import {
  Pagination,
  PaginationGap,
  PaginationList,
  PaginationNext,
  PaginationPage,
  PaginationPrevious,
} from '@/ui-components/Pagination'

const SimplePagination = ({
  totalPages = 10,
  onPaginate,
  currentPage,
}: {
  totalPages?: number
  onPaginate: (page: number) => void
  currentPage: number
}) => {
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1)

  const visiblePages = pages.filter((page) => {
    // First and last page should always be visible
    if (page === 1 || page === totalPages) return true

    // Show the current page and the pages before and after it
    if (page === currentPage || page === currentPage - 1 || page === currentPage + 1) return true

    return false
  })

  return (
    <Pagination className="max-w-md">
      <PaginationPrevious
        disabled={currentPage === 1}
        onClick={() => onPaginate(currentPage - 1)}
      />
      <PaginationList>
        {pages.map((page) => {
          if (visiblePages.includes(page)) {
            return (
              <PaginationPage
                key={page}
                onClick={() => onPaginate(page)}
                current={page === currentPage}
              >
                {page}
              </PaginationPage>
            )
          }

          //    Show 3 dots before and after visible pages
          if (page === currentPage - 2 || page === currentPage + 2) {
            return <PaginationGap key={`gap-${page}`} />
          }

          return null
        })}
      </PaginationList>
      <PaginationNext
        disabled={currentPage === totalPages}
        onClick={() => onPaginate(currentPage + 1)}
      />
    </Pagination>
  )
}

export default SimplePagination
